/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

// tslint:disable:variable-name

import { ID, PrintEntryPoint, WithVersion } from '@gh/common-shared-data';
import { createEnum, EnumSet } from '@gh/core-data';
import { createLink } from '@gh/core-util';

import { CommunicationAttachmentDto } from '../communications';
import { ContactDeliveryMethod } from '../contacts';
import { QuotationBase, QuoteStructureHeadingDto } from '../leads';

export type LetterFinalVersionDto = {
  contactId: ID;
  salesFolderId?: ID;
  jobId?: ID;
  filledTemplate: LetterDto;
};

export type LetterDto = {
  googleId: string;
  name: string;
  extension: string;
  link: string;
  mimeType: string;
  deliveryBy: ContactDeliveryMethod;
  parents: string[];
  letterTemplate: string;
  created?: Date;
  communicationId?: ID;
};

export const QuotationPrintMethod = createEnum('QUOTATION_PRINT_METHOD', {
  SendByEmail: 'SEND_BY_EMAIL',
  PrintQuote: 'PRINT_QUOTE',
});
export type QuotationPrintMethod = EnumSet<typeof QuotationPrintMethod>;

export type QuotationPrintRequestDto = WithVersion<{
  salesFolderId: ID;
  quotationId: ID;
  type: QuotationBase;
  isAuthorityToProceedRequired: boolean;
  isPrintTakeOff: boolean;
  isShowBasePrice: boolean;
  isForEstimator: boolean;
  entryPoint: PrintEntryPoint;
  headings?: QuoteStructureHeadingDto[];
  method?: QuotationPrintMethod;
}>;

export type QuotationPrintResponseDto = {
  quoteDoc: LetterDto;
  authorityDoc?: LetterDto;
  hpTopReport?: LetterDto;
  extraAttachments: CommunicationAttachmentDto[];
};

export function createLinkFromLetter(letter: LetterDto): string {
  return createLink(letter.link, letter.name);
}
